import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  ViewChild,
} from '@angular/core';
import { map } from 'rxjs/operators';
import { OrderformFascade } from '../../fascades/orderform.fascade';
import { IframeModalComponent } from '../iframe-modal/iframe-modal.component';
import { IframeModalService } from '../iframe-modal/iframe-modal.service';

@Component({
  selector: 'orderform-legal-notice',
  templateUrl: './legal-notice.component.html',
  styleUrls: ['./legal-notice.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegalNoticeComponent {
  legalNotes$ = this._orderformFascade.settings$.pipe(
    map((setting) => setting.static_texts.legal_notes)
  );

  constructor(
    private _orderformFascade: OrderformFascade,
    private _iframeModal: IframeModalService
  ) {}

  @HostListener('click', ['$event'])
  public onClickLegalLink(e: Event) {
    const anchor = e.target as Element;
    if (!(anchor.tagName === 'A' && anchor.classList.contains('legal_link'))) {
      return;
    }

    e.preventDefault();

    this._iframeModal.open(
      anchor.getAttribute('title'),
      anchor.getAttribute('href')
    );
  }

  public trackByIndex(index: number) {
    return index;
  }
}
